import "./about.css"



export default function About() {
  return (
    <div className="about">


      <div className="mission-section">
        <h4>Our Mission</h4>
        
        <h1>
          Making strategic superintelligence that works for the public good
        </h1>
      </div>

      <div className="about-content">
        <p>
          We are the Princeton Language+Law, Artificial Intelligence, & Society Lab (POLARIS Lab). 
          Through interdisciplinary research at the intersection of AI and law,
          we work to ensure AI technologies serve the public good.
        </p>

        <div className="mission-section">
          <h3>Vision</h3>
        </div>

        <p>
          In 2018, we wrote <a href="https://arxiv.org/abs/1709.06560">Deep Reinforcement Learning that Matters</a>. These works outline a vision for AI research that focuses on rigorous scientific research, but also emphasizes picking hard problems to work on with positive societal impact. Our work is guided by this vision in three main areas:
          <br/><br/>
          <p>
            <strong>Strategic Superintelligence:</strong> We work on techniques for developing reliable, superhuman artificial intelligence systems in strategic decision-making settings, often with real-world partners. 
          </p>
          <p>
            <strong>AI Law:</strong> The law will be crucial for ensuring positive societal outcomes from AI. We're working through ways that AI and the law can co-evolve together. In the short term, AI is stretching the limits of existing law & policy, from copyright law to labor policy. Action will be needed to resolve these ambiguities and tensions. We work on identifying these issues, and proposing equitable solutions.
          </p>
          <p>
            <strong>Law-Following AI, AI Alignment, and AI Safety:</strong> We develop new tools to help AI systems follow natural language laws, and tools to better understand flaws in legal language. These law-following systems will be necessary to keep strategic superintelligence systems in check. But this is also a hard challenge—it requires understanding years of legal theory around interpretation of laws to prevent AI systems from finding loopholes.
          </p>
        </p>

        <div className="mission-section">
          <h3>Impact</h3>
        </div>

        <p>
          The POLARIS lab focuses on real-world impact, and as a result, our work has regularly received popular press coverage in the <a href="https://www.nytimes.com/2023/10/19/technology/guardrails-artificial-intelligence-open-source.html">New York Times</a>, <a href="https://www.washingtonpost.com/technology/2024/03/05/ai-research-letter-openai-meta-midjourney/">Washington Post</a>, <a href="https://www.wsj.com/articles/researchers-are-developing-tools-to-calculate-ais-carbon-footprint-11594978202">Wall Street Journal</a>, and <a href="https://www.science.org/doi/10.1126/science.359.6377.725">Science</a>.
        </p>

        <p>
          We've helped policymaking efforts in various ways. Our work on AI safety and governance has been cited and used by <a href="https://nvlpubs.nist.gov/nistpubs/ai/NIST.AI.800-1.ipd.pdf">National Institute of Standards and Technology</a>, <a href="https://www.ntia.gov/sites/default/files/publications/ntia-ai-open-model-report.pdf">National Telecommunications and Information Administration</a> (NTIA), <a href="https://vimeo.com/event/3784739">National Artificial Intelligence Advisory Committee (NAIAC)</a>, <a href="https://www.copyright.gov/1201/2024/USCO-letters/Letter%20from%20Department%20of%20Justice%20Criminal%20Division.pdf">Department of Justice</a>, <a href="https://arxiv.org/abs/2204.11910">Internal Revenue Service</a>, <a href="https://reglab.github.io/racialcovenants/">Santa Clara County</a>, and <a href="https://www.markey.senate.gov/news/press-releases/markey-heinrich-eshoo-beyer-introduce-legislation-to-investigate-measure-environmental-impacts-of-artificial-intelligence">legislators</a>.
        </p>
          
        <p>
          Companies, like OpenAI, have <a href="https://openai.com/index/gpt-4v-system-card/">adopted</a> our recommendations to improve the safety of their systems. And top AI conferences have adopted our recommendations for <a href="https://neuripsconf.medium.com/introducing-the-neurips-2021-paper-checklist-3220d6df500b">reproducibility standards</a> and environmental impact reporting.
        </p>
              
        <div className="location-section">
          <h2>Our Location</h2>
          <img className="robot-in-front-of-building"
            alt="Cute robot in front of Nassau Hall" 
            src={require("./robot_in_front_of_building.png")}
          />
          <p>
            We are housed within Princeton's 
            <a target="_blank" rel="noreferrer" href="https://citp.princeton.edu/"> Center for Information Technology Policy</a> 
            at 303 Sherrerd Hall, Princeton, NJ 08544.
          </p>
          <p>
            Join us at Princeton! Once you're here, let us know 
            <a target="_blank" rel="noreferrer" href="https://www.peterhenderson.co/advising/"> your interest</a> in 
            the lab. For media inquiries, please email peter (dot) henderson (at) princeton (dot) edu.
          </p>
        </div>
      </div>
    </div>
  );
}
